import React from "react";
import { cn } from "@/lib/utils";
import { PLATFORM_LABELS } from "@/lib/constants";
import { BookOpen } from "lucide-react";
import {
  LinkedInLogo,
  XLogo,
  InstagramLogo,
  FacebookLogo,
  ThreadsLogo,
  BlueskyLogo,
  ShortsLogo,
} from "@/components/brand/PlatformLogos";

// Authentic platform branding: each badge uses the real brand mark + brand-tinted
// background so the platform is identifiable at a glance everywhere in the app.
const MAP = {
  linkedin:        { logo: LinkedInLogo,  bg: "rgba(10,102,194,0.14)",  border: "rgba(10,102,194,0.32)",  text: "#4DA3F0" },
  x:               { logo: XLogo,         bg: "rgba(255,255,255,0.08)", border: "rgba(255,255,255,0.22)", text: "#E7E9EA", iconColor: "#E7E9EA" },
  twitter:         { logo: XLogo,         bg: "rgba(255,255,255,0.08)", border: "rgba(255,255,255,0.22)", text: "#E7E9EA", iconColor: "#E7E9EA" },
  facebook:        { logo: FacebookLogo,  bg: "rgba(24,119,242,0.12)",  border: "rgba(24,119,242,0.30)",  text: "#5B9BFF" },
  instagram:       { logo: InstagramLogo, bg: "rgba(228,64,95,0.12)",   border: "rgba(228,64,95,0.28)",   text: "#F0699E" },
  youtube_shorts:  { logo: ShortsLogo,    bg: "rgba(255,0,51,0.10)",    border: "rgba(255,0,51,0.28)",    text: "#FF6B6B" },
  threads:         { logo: ThreadsLogo,   bg: "rgba(255,255,255,0.08)", border: "rgba(255,255,255,0.22)", text: "#E7E9EA", iconColor: "#E7E9EA" },
  bluesky:         { logo: BlueskyLogo,   bg: "rgba(17,133,254,0.14)",  border: "rgba(17,133,254,0.32)",  text: "#58A6FF" },
  blog:            { logo: null,          icon: BookOpen, bg: "rgba(148,160,178,0.14)", border: "rgba(148,160,178,0.26)", text: "#9EA0A6" },
};

export function PlatformBadge({ platform, className, showIcon = true, compact = false, size = "sm", ...rest }) {
  const cfg = MAP[platform] || MAP.blog;
  const Logo = cfg.logo;
  const Fallback = cfg.icon;
  const iconSize = size === "lg" ? 16 : 12;

  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full border font-medium",
        compact ? "px-1.5 py-0.5 text-[10.5px]" : "px-2 py-0.5 text-xs",
        className,
      )}
      style={{ backgroundColor: cfg.bg, borderColor: cfg.border, color: cfg.text }}
      data-testid={`platform-badge-${platform}`}
      {...rest}
    >
      {showIcon && (
        Logo ? (
          <span className="inline-flex shrink-0" style={cfg.iconColor ? { color: cfg.iconColor } : undefined}>
            <Logo size={iconSize} />
          </span>
        ) : Fallback ? (
          <Fallback className="h-3 w-3" />
        ) : null
      )}
      {!compact && <span>{PLATFORM_LABELS[platform] || platform}</span>}
    </span>
  );
}
